var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('skills-list',{attrs:{"title":_vm.title,"menu":_vm.menu}}),_c('logo'),_c('background-play'),_c('contact-me-line'),_c('animals-walk')],1)}
var staticRenderFns = []

export { render, staticRenderFns }